module.exports = __webpack_public_path__ + "img/tscfunding-square.f05c1fe8.png";